<template>
  <div class="container">
    <img class="back-style" :src="this.image" />
    <div class="Toast-vino">
      <div class="Btn-Container-vino" @click="go">
        <div class="icon-container-vino">
          <img :src="iconRate" />
        </div>
        <div class="txt-container-vino txt-rate">
            {{ $t('tasting.rate') }}
        </div>
      </div>
      <div class="Btn-Container-vino" @click="$emit('click')">
        <div class="icon-container-vino">
          <img :src="iconWine"/>
        </div>
        <div class="txt-container-vino">
            {{ $t('tasting.taste') }}
        </div>
      </div>
    </div>

    <div :class="!isDesktop ? 'TitleMobile' : 'Title'">
      {{ title }}
    </div>

    <div class="Infos">
      <div class="Naming-Container">
        <span :class="!isDesktop ? 'Naming-Mobile' : 'Naming'">{{ this.naming }}</span>
        <span v-if="this.isProduct && this.naming != '' && this.region != ''" :class="!isDesktop ? 'Sep-Mobile' : 'Sep'">-</span>
        <span :class="!isDesktop ? 'Region-Mobile' : 'Region'">{{ this.region }}</span>
      </div>
      <div class="Years-Container">
        <span :class="!isDesktop ? 'Type-Mobile' : 'Type'">{{ this.type }}</span>
        <span v-if="this.isProduct && this.type != '' && this.millesime != ''" :class="!isDesktop ? 'Sep-Mobile' : 'Sep'">-</span>
        <span :class="!isDesktop ? 'Years-Mobile' : 'Years'">{{ this.millesime }}</span>
      </div>
      <div class="Domain-Container">
        <span :class="!isDesktop ? 'Domain-Mobile' : 'Domain'">{{ this.domainName }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import unrated from '@/assets/rate_empty.png'
import rated from '@/assets/rate_full.png'
import degusted from '@/assets/wine_full.png'
import undegusted from '@/assets/wine_empty.png'

export default {
  name: 'VvDesktopTasteTile',
  props: {
    title: {
      type: String,
      required: true
    },
    ratingPath: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: false
    },
    status: {
      type: Object,
      required: false
    },
    bottleId: {
      type: String,
      required: false
    }
  },
  computed: {
    ...mapGetters([
      'getBottleById'
    ]),
    iconRate() {
      if (this.status && 'rating' in this.status) return rated
      else if (!this.status) return unrated
      else return unrated
    },
    iconWine() {
      if (this.status && this.status['complete']) return degusted
      else if (!this.status) return undegusted
      else return undegusted
    },
    product() {
      return this.getBottleById(this.bottleId)
    },
    isProduct(){
      return this.product ? true : false
    },
    naming () {
      return this.product ? this.product.naming : ''
    },
    millesime () {
      return this.product ? this.product.millesime : ''
    },
    region () {
      return this.product ? this.product.region : ''
    },
    domainName () {
      return this.product ? this.product.domainName : ''
    },
    isDesktop() {
      return ['mobile', 'tablet'].includes(this.$mq) ? false : true
    },
    type () {
      return this.product ? this.product.type : ''
    }
  },
  methods: {
    go() {
      if (this.$route.path.includes("/theme/")) {
        localStorage.setItem('comingFromTasteThemeId', this.$route.params.themeId)
      }
      this.$router.push({ name: 'tasting-rating', params: { tastingId: this.ratingPath } })
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.container {
  display: flex;
  margin-bottom: 30px;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  transition: all 200ms linear;

  .back-style {
    width: 100%;
    height: auto;
    border-radius: 20px;
  }

  .Text-Title {
    display: flex;
    align-self: center;
    font-size: medium;
    font-weight: bold;
    padding-bottom: 20px;
    padding-top: 20px;
  }

  .Toast {
    width: 100%;
    @media screen and (min-width: 1481px) {
      width: 85%;
    }
    display: flex;
    justify-content: space-evenly;
    flex-direction: row;

    .Btn-Container {
      background-color: $primary;
      border-radius: 30px;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      align-self: center;
      padding: 5px;
      margin: 5px;
      cursor: pointer;

      .icon-container {
        width: 30%;
        height: 100%;
        display: flex;
        align-self: center;
        align-items: center;
      }

      img {
        height: 25px;
        width: 25px;
      }

      .txt-container-note {
        width: 100%;
        height: 100%;
        display: flex;
        align-self: center;
        align-items: center;
        margin-left: 10px;
        @media screen and (min-width: 1481px) {
          margin-left: 20px;
        }
      }

      .txt-container {
        width: 100%;
        height: 100%;
        display: flex;
        align-self: center;
        align-items: center;
        @media screen and (min-width: 1481px) {
          margin-left: 8px;
        }
      }

      .Text-Btn {
        align-self: center;
        font-size: xx-small;
        font-weight: bold;
        color: $font-button;
      }
    }
  }

  .Toast-vino {
    position: relative;
    width: 80%;
    height: 35px;
    display: flex;
    flex-direction: row;
    top: -22.5px;
    margin-bottom: -25px;
    justify-content: space-evenly;

    .Btn-Container-vino {
      background-color: $primary;
      border-radius: 30px;
      width: 60%;
      @media screen and (min-width: 1024px) and (max-width: 1480px) {
        width: 60%;
      }
      @media screen and (min-width: 1240px) and (max-width: 1480px) {
        width: 40%;
      }
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      padding: 5px;
      margin: 5px;
      cursor: pointer;

      .icon-container-vino {
        width: 30%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }

      img {
        height: 25px;
        width: 25px;
      }

      .txt-container-vino {
        width: 70%;
        height: 100%;
        display: flex;
        align-items: center;
        padding-top: 2px;
        justify-content: center;
        font-size: small;
        font-weight: bold;
        color: $font-button;
      }
    }
  }
  .TitleMobile {
    color: black;
    font-weight: bold;
    text-align: center;
    margin-top: 10px;
    font-size: smaller;
  }

  .Title {
    color: black;
    font-weight: bold;
    text-align: center;
    margin-top: 20px;
    font-size: 25px;
  }

  .Infos {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: smaller;
    padding: 0 10px;
    box-sizing: border-box;
    margin-top: 5px;
    margin-bottom: 10px;
    text-align: center;

    .Naming-Container {
      font-style: italic;
      font-size: x-small;

      .Naming {
        margin-right: 5px;
      }
      .Region {
        margin-left: 5px;
      }
      .Naming-Mobile {
        font-size: xx-small;
      }
      .Region-Mobile {
        display: none;
      }
      .Sep-Mobile {
        display: none;
      }
    }
    
    .Years-Container {
      font-style: italic;
      font-size: x-small;

      .Type {
        margin-right: 5px;
      }
      .Years {
        margin-left: 5px;
      }

      .Type-Mobile {
        display: none;
      }

      .Years-Mobile {
        display: none;
      }
      
      .Sep-Mobile {
        display: none;
      }
    }

    .Domain-Container {
      font-size: small;

      .Domain-Mobile {
        font-size: xx-small;
      }
    }
  }
}
</style>
